import React from 'react'
import {
  Create,
  TextInput,
  required,
  SimpleForm,
} from 'react-admin'

export default props => (
  <Create {...props} title="Cadastrar novo grupo de permissões">
    <SimpleForm sx={{ maxWidth: 600 }}>
      <TextInput source="name" label="Nome" InputProps={{ autoComplete: 'off' }} validate={required()} sx={{ minWidth: 300 }} />
    </SimpleForm>
  </Create>
)
